import {useEffect, useState} from 'react';
import type { ReactNode } from 'react';
import {Navigate, useLocation} from 'react-router-dom'
import useZohoSalesIQ, { cleanupZohoSalesIQ } from "@shared/hooks/useZohoSalesIQ";

interface PrivateRouteProps {
    children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const location = useLocation();

    // El hook no toma argumentos (ver shared/hooks/useZohoSalesIQ.ts); este string ya se
    // descartaba en runtime antes de la migración, así que quitarlo no cambia el comportamiento.
    useZohoSalesIQ();

    useEffect(() => {
        let storeUser = localStorage.getItem("user");
        if (storeUser && storeUser !== "") {
            let user = JSON.parse(storeUser);
            if (user.token !== "") {
                setIsAuthenticated(true);
                return;
            }
        }

        cleanupZohoSalesIQ(import.meta.env.VITE_ZOHO_SCRIPT_ID);
        setIsAuthenticated(false);
    }, [location]);

    if (isAuthenticated === null) {
        return <></>
    }

    return (
        !isAuthenticated ? (
            <Navigate to='/'/>
        ) : (
            children
        )
    );
};

export default PrivateRoute;
